__turbopack_context__.v({
  "section-webinar": "styles-module-scss-module__vTSheq__section-webinar",
  "videoplayer": "styles-module-scss-module__vTSheq__videoplayer",
  "videoplayer__image": "styles-module-scss-module__vTSheq__videoplayer__image",
  "videoplayer__image_main-image": "styles-module-scss-module__vTSheq__videoplayer__image_main-image",
  "webinar": "styles-module-scss-module__vTSheq__webinar",
  "webinar__info-text": "styles-module-scss-module__vTSheq__webinar__info-text",
  "webinar__title": "styles-module-scss-module__vTSheq__webinar__title",
});
